/**
 * MapPlaceCluster Component
 * Renders a cluster badge with count and zoom icon
 */

import React, { useCallback } from 'react';
import { useHover } from '../MapLabels/MapLabelsHooks';
import { ZoomIcon } from '../MapLabels/MapLabelIcons';
import './MapPlaceCluster.scss';

/**
 * Map Place Cluster Component - styled zoom icon with count label
 */
const MapPlaceCluster = ({
  cluster, position, onClusterClick, globalLabelVisible = true, boostCount = 0,
}) => {
  // All hooks must be called before any conditional returns
  const [isHovered, hoverHandlers] = useHover();
  const { count, labels } = cluster;
  const displayCount = count + boostCount;

  const handleClick = useCallback((e) => {
    e.stopPropagation();
    onClusterClick?.(cluster);
  }, [cluster, onClusterClick]);

  // Extract label text from place objects for tooltip
  const labelNames = labels?.map((place) => place?.pin?.label_text || '').filter(Boolean);
  const tooltipText = labelNames?.slice(0, 3).join(', ') + (labelNames?.length > 3 ? '...' : '');

  // Hide cluster when global toggle is off (must be after all hooks)
  if (!globalLabelVisible) {
    return null;
  }

  return (
    <div
      className={`htmlClusterBadge ${isHovered ? 'htmlClusterBadge--hovered' : ''}`}
      style={{ left: `${position.x}%`, top: `${position.y}%` }}
      onClick={handleClick}
      title={tooltipText}
      data-cluster-id={cluster.id}
      {...hoverHandlers}
    >
      <div className="htmlClusterBadge__label">
        <span className="htmlClusterBadge__text">{displayCount} More</span>
      </div>
      <ZoomIcon className="htmlClusterBadge__icon" />
    </div>
  );
};

export default MapPlaceCluster;
